<script>
	//export let name;
	import Layout from './Layout.svelte'
	import {setupI18n} from './i18n.js';
	let title="Centraline Dip. Informatica"

	setupI18n();
</script>

<!-- <main>
	<h1>Hello {name}!</h1>
	<p>Visit the <a href="https://svelte.dev/tutorial">Svelte tutorial</a> to learn how to build Svelte apps.</p>
</main> -->
<svelte:head>
   <title>{title}</title>
</svelte:head>

<Layout title={title}></Layout>

<!-- <style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style> -->